<div class="main-header" [style.background-color]="background" [style.color]="foreground">
    <div class="brand" [ngClass]="{'flex flex-row items-center gap-2' : location()=='rfq'}">
        
        <a class="logo" routerLink="/">
            <img [src]="'assets/svg/logo-main.svg'">
        </a>
    </div>

    <div class="indicator-item">
            <a class="become-vendor-link" [routerLink]="['/apply-for-vendor']">
                {{"become_vendor"|translate}}
            </a>
        </div>

    <div class="nav">
        <div class="indicator-item">
            <button class="mobile-header__menu-button" (click)="menu.open()">
                <mat-icon class="text-default-blue text-2xl w-7 h-7" fontIcon="person"></mat-icon>
            </button>
        </div>

        

        <div class="indicator-item">
            <button 
                class="mobile-header__language-button" 
                (click)="translateService.currentLang == 'ar' ? changeLangage('en') : changeLangage('ar')">
                {{ translateService.currentLang == 'ar' ? 'AR' : 'EN' }}
            </button>
        </div>

        

        <!-- <div class="indicator-item">
            <button class="mobile-header__cart-button" [routerLink]="['/cart']">
                <mat-icon class="text-default-blue text-2xl w-7 h-7" fontIcon="shopping_cart"></mat-icon>
                <span class="cart-badge" *ngIf="(cart.quantity$|async) > 0">{{cart.quantity$|async}}</span>
            </button>
        </div> -->

        <!-- <div class="indicator-item">
            <button class="mobile-header__search-button" (click)="searchDropdown.toggle()">
                <mat-icon class="text-default-blue text-2xl w-7 h-7" fontIcon="search"></mat-icon>
            </button>
        </div> -->
    </div>

    

    <app-search appDropdown="mobile-header__search--open" class="mobile-header__search" location="mobile-header"
        #search="search" #searchDropdown="appDropdown" [searchDropdown]="searchDropdown">
    </app-search>
</div>
<div class="scrollable-links-container">
    <div class="scrollable-links">
        <div class="topbar__item">
            <div class="topbar-dropdown" #sectorsMenuContainer [class.topbar-dropdown--opened]="isSectorsMenuOpen">
                <button class="topbar-dropdown__btn sectors-menu btn btn-primary" type="button"
                    (click)="$event.stopPropagation(); toggleSectors()">
                    <div class="flex flex-row items-center justify-center">
                        <div class="label">{{"categories"|translate}}</div>
                        <div class="icon">
                            <mat-icon class="mat-icon-rtl-mirror" [inline]="true" fontIcon="chevron_right"></mat-icon>
                        </div>
                    </div>
                </button>

                <div class="topbar-dropdown__body _sector" *ngIf="isSectorsMenuOpen">
                    <div class="rounded-2xl">
                        <app-sectors-menu (hasSelected)="onSectorsSelected()"></app-sectors-menu>
                    </div>
                </div>
            </div>
        </div>
        <div class="topbar__item">
            <div class="topbar-dropdown" #rfqMenuContainer [class.topbar-dropdown--opened]="isRfqMenuOpen">
                <button class="topbar-dropdown__btn nav-link btn btn-primary relative" type="button"
                    (click)="toggleRfq(); $event.stopPropagation()">
                    @if(notifications()?.quote){
                    <div class="w-2 h-2 rounded-full absolute bg-[#ff5050] rtl:left-0 ltr:right-0 top-0">
                    </div>
                    }
                    <div class="flex flex-row items-center justify-center">
                        <div class="label">{{'rfq_center'|translate}}</div>
                        <div class="icon">
                            <mat-icon class="mat-icon-rtl-mirror" [inline]="true" fontIcon="chevron_right"></mat-icon>
                        </div>
                    </div>
                </button>

                <div class="topbar-dropdown__body _sector rfq-body" *ngIf="isRfqMenuOpen">
                    <div class="rounded-2xl">
                        <div class="categories-list" [attr.lang]="translateService.currentLang">
                            <div class="megamenu">
                                <div class="megamenu__body">
                                    <div class="main-title">{{ 'rfq_center'|translate }}</div>

                                    <a class="category-link" [routerLink]="['/rfq/center']" (click)="onRfqSelected()">
                                        <div class="icon"><img class="!w-9 !h-9 brightness-0 saturate-0 opacity-60" src="assets/svg/quote/center1.svg"></div>
                                        <div class="title font-bold">{{ 'center'|translate }}</div>
                                    </a>

                                    <a class="category-link" [routerLink]="['/rfq/dashboard']" (click)="onRfqSelected()">
                                        <div class="icon"><img class="!w-9 !h-9 brightness-0 saturate-0 opacity-60" src="assets/svg/quote/dashboard1.svg"></div>
                                        <div class="title font-bold">{{ 'dashboard'|translate }}</div>
                                    </a>

                                    <a class="category-link" [routerLink]="['/boq-projects']" (click)="onRfqSelected()">
                                        <div class="icon"><img class="!w-9 !h-9 brightness-0 saturate-0 opacity-60" src="assets/svg/quote/boq_projects1.svg"></div>
                                        <div class="title font-bold">{{ 'BoqProjects1'|translate }}</div>
                                    </a>

                                    <a class="category-link" [routerLink]="['/rfq/request']" (click)="onRfqSelected()">
                                        <div class="icon"><img class="!w-9 !h-9 brightness-0 saturate-0 opacity-60" src="assets/svg/quote/request1.svg"></div>
                                        <div class="title font-bold">{{ 'quotation_requests'|translate }}</div>
                                    </a>

                                    <a class="category-link" [routerLink]="['/rfq/list']" (click)="onRfqSelected()">
                                        <div class="icon"><img class="!w-9 !h-9 brightness-0 saturate-0 opacity-60" src="assets/svg/quote/my_requests1.svg"></div>
                                        <div class="title font-bold flex items-center gap-2">
                                            {{ 'RFQ_List'|translate }}
                                            @if(notifications()?.quote?.length){
                                                <span class="badge badge-primary">{{ notifications().quote.length }}</span>
                                            }
                                        </div>
                                    </a>

                                    <a class="category-link" [routerLink]="['/rfq/items']" (click)="onRfqSelected()">
                                        <div class="icon"><img class="!w-9 !h-9 brightness-0 saturate-0 opacity-60" src="assets/svg/quote/my_items1.svg"></div>
                                        <div class="title font-bold">{{ 'my_items'|translate }}</div>
                                    </a>

                                    <a class="category-link" [routerLink]="['/rfq/addresses']" (click)="onRfqSelected()">
                                        <div class="icon"><img class="!w-9 !h-9 brightness-0 saturate-0 opacity-60" src="assets/svg/quote/address1.svg"></div>
                                        <div class="title font-bold">{{ 'addresses'|translate }}</div>
                                    </a>

                                    <a class="category-link" [routerLink]="['/rfq/projects']" (click)="onRfqSelected()">
                                        <div class="icon"><img class="!w-9 !h-9 brightness-0 saturate-0 opacity-60" src="assets/svg/quote/projects1.svg"></div>
                                        <div class="title font-bold">{{ 'hook_works'|translate }}</div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <a class="nav-link" [routerLink]="['/site', 'stores']">{{'stores'|translate}}</a>

    </div>
</div>
<!-- <app-header-topbar></app-header-topbar> -->
<!-- <app-categories-underbar></app-categories-underbar> -->